import { Button, TableCell } from '@material-ui/core';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { showMessage } from 'app/store/fuse/messageSlice';
import ConfirmDialog from 'modules/ui/component/ConfirmDialog';
import ClientRegistryStatus from '../dto/ClientRegistryStatus';

function ClientRegistryStatusTableCell(props) {
	const dispatch = useDispatch();
	const [showConfirm, setShowConfirm] = useState(false);
	const [action, setAction] = useState(null);

	const closeConfirm = () => {
		setShowConfirm(false);
		setAction(null);
	};

	const onHandle = () => {
		let request;

		console.log(props.item);

		if (action === 'accept') {
			request = props.button.service.accept(
				props.item.id,
				props.item.project ? props.item.project.id : null,
				props.item.location,
				props.item.deviceType ? props.item.deviceType.id : null
			);
		} else if (action === 'reject') {
			request = props.button.service.reject(props.item.id);
		} else if (action === 'pending') {
			request = props.button.service.setToPending(props.item.id);
		} else {
			return;
		}

		request
			.then(resp => {
				dispatch(showMessage({ message: resp ? 'Registry status change completed.' : 'Registry status change failed.' }));
				if (resp) dispatch({ type: `${props.config.key}/event/setNeedDataReload` });
			})
			.catch(() => {
				dispatch(showMessage({ message: 'Registry status change failed.' }));
			})
			.finally(() => {
				closeConfirm();
			});
	};

	const getConfirmDescription = () => {
		if (action === 'accept') return 'Are you sure you want to accept this device?';
		if (action === 'reject') return 'Are you sure you want to reject this device?';
		if (action === 'pending') return 'Are you sure you want to set this device back to pending?';

		return 'Are you sure you want to do this?';
	};

	if (props.item.registryStatus === null) {
		return (
			<TableCell className="p-4 md:p-16" scope="row">
				-
			</TableCell>
		);
	}

	if (props.item.registryStatus === 'PENDING') {
		return (
			<TableCell className="w-auto text-center" padding="none">
				<div className="flex flex-row p-4 md:p-16">
					<Button
						variant="contained"
						color="secondary"
						className="mr-6"
						onClick={() => {
							setAction('accept');
							setShowConfirm(true);
						}}
					>
						Accept
					</Button>

					<Button
						variant="contained"
						color="primary"
						onClick={() => {
							setAction('reject');
							setShowConfirm(true);
						}}
					>
						Reject
					</Button>
				</div>

				<ConfirmDialog
					show={showConfirm}
					title="Confirm"
					description={getConfirmDescription()}
					onYes={() => onHandle()}
					onClose={() => closeConfirm()}
				/>
			</TableCell>
		);
	}

	if (props.item.registryStatus === 'REJECTED') {
		return (
			<TableCell className="p-4 md:p-16" scope="row">
				<div className="flex flex-row">
					<Button
						variant="contained"
						color="secondary"
						className="mr-6"
						onClick={() => {
							setAction('accept');
							setShowConfirm(true);
						}}
					>
						Accept
					</Button>

					<Button
						variant="contained"
						color="primary"
						onClick={() => {
							setAction('pending');
							setShowConfirm(true);
						}}
					>
						Set to pending
					</Button>
				</div>

				<ConfirmDialog
					show={showConfirm}
					title="Confirm"
					description={getConfirmDescription()}
					onYes={() => onHandle()}
					onClose={() => closeConfirm()}
				/>
			</TableCell>
		);
	}

	return (
		<TableCell className="p-4 md:p-16" scope="row">
			{ClientRegistryStatus[props.item.registryStatus]}
		</TableCell>
	);
}

export default ClientRegistryStatusTableCell;